// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";

// function Slider() {
//   const [currentSlide, setCurrentSlide] = useState(1);
//   const [totalSlides, setTotalSlides] = useState(0);
//   const [Banner, setBanner] = useState([]);
//   const textIndexRef = useRef(0);
//   const carouselInstanceRef = useRef(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/home_banner_list"
//       );
//       setBanner(response.data.data);
//       setTotalSlides(response.data.data.length);
//     };

//     fetchData();
//   }, []);

  
//   const rotateText = (index) => {
//     const items = document.querySelectorAll(".circle-list li");
//     if (!items.length) return;

//     items.forEach((item, i) => {
//       item.classList.remove("active");
//       item.style.transform = `rotateY(${(i - index) * 51}deg) translateZ(160px)`;
//     });

//     items[index].classList.add("active");
//   };

//   useEffect(() => {
//     const carouselEl = document.getElementById("carouselId");
//     if (!carouselEl || Banner.length === 0) return;

  
//     if (carouselInstanceRef.current) {
//       carouselInstanceRef.current.dispose();
//       carouselInstanceRef.current = null;
//     }

  
//     if (window.bootstrap?.Carousel) {
//       carouselInstanceRef.current = new window.bootstrap.Carousel(carouselEl, {
//         interval: 3000,
//         pause: 'hover',
//         ride: 'carousel'
//       });
//     }

//     const handleSlideChange = (event) => {
//       const newSlide = event.to + 1;
//       setCurrentSlide(newSlide);

      
//       const items = document.querySelectorAll(".circle-list li");
//       if (items.length > 0) {
//         textIndexRef.current = (textIndexRef.current + 1) % items.length;
//         rotateText(textIndexRef.current);
//       }
//     };

//     carouselEl.addEventListener("slide.bs.carousel", handleSlideChange);

//     return () => {
//       carouselEl.removeEventListener("slide.bs.carousel", handleSlideChange);
      
    
//       if (carouselInstanceRef.current) {
//         carouselInstanceRef.current.dispose();
//         carouselInstanceRef.current = null;
//       }
//     };
//   }, [Banner]); 

//   useEffect(() => {
//     if (Banner.length > 0) {
//       rotateText(0);
//     }
//   }, [Banner]);

//   return (
//     <section>
//       <div className="row">
        
//         <div className="col-lg-6 banner-left">
//             <div className="circle-3d">
//             <div className="video-sphere">
//               <video
//                 className="sphere-video"
//                 src="/NLFanimation.mp4"
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//               />
//             </div>
//           </div>

//           </div>

//       <div className="container-fluid col-lg-6 px-0 ">
//         <div
//           id="carouselId"
//           className="carousel slide nlf-carousel"
//           data-bs-ride="carousel"
//           data-bs-interval="3000"
//           data-bs-pause="hover"
//         >
//           <div
//             className="carousel-inner"
//             role="listbox"
//             style={{
//               backgroundImage: `url(https://cyberathon.com/NLF/${Banner[currentSlide - 1]?.bnr_image})`,
//               backgroundRepeat: "no-repeat",
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//             }}
//           >
//             {Banner.map((Data, index) => (
//               <div
//                 key={index}
//                 className={`carousel-item ${index === 0 ? "active" : ""}`}
//               >
//                 <div className="banner-row">
//                   <div className="banner-image text-center">
//                     <h1 className="text-white mb-3">{Data.bnr_heading}</h1>
//                     <img src={`https://cyberathon.com/NLF/${Data.bnr_image}`} alt={Data.bnr_heading} />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="slide-number">
//             {currentSlide} / {totalSlides}
//           </div>

//           <button
//             className="nlf-carousel-control nlf-carousel-prev"
//             type="button"
//             data-bs-target="#carouselId"
//             data-bs-slide="prev"
//           >
//             <span className="nlf-control-icon" aria-hidden="true">
//               <svg viewBox="0 0 24 24">
//                 <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
//               </svg>
//             </span>
//           </button>

//           <button
//             className="nlf-carousel-control nlf-carousel-next"
//             type="button"
//             data-bs-target="#carouselId"
//             data-bs-slide="next"
//           >
//             <span className="nlf-control-icon" aria-hidden="true">
//               <svg viewBox="0 0 24 24">
//                 <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"></path>
//               </svg>
//             </span>
//           </button>
//         </div>
//       </div>
//       </div>
//     </section>
//   );
// }

// export default Slider;

// Real old code 10 march start

// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import styles from "./Slider2.module.css";
// function Slider() {
//   const [currentSlide, setCurrentSlide] = useState(1);
//   const [totalSlides, setTotalSlides] = useState(0);
//   const [Banner, setBanner] = useState([]);
//   const textIndexRef = useRef(0);
//   const carouselInstanceRef = useRef(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/home_banner_list"
//       );
//       setBanner(response.data.data);
//       setTotalSlides(response.data.data.length);
//     };

//     fetchData();
//   }, []); 

  
  
//   const rotateText = (index) => {
//     const items = document.querySelectorAll(".circle-list li");
//     if (!items.length) return;

//     items.forEach((item, i) => {
//       item.classList.remove("active");
//       item.style.transform = `rotateY(${(i - index) * 51}deg) translateZ(160px)`;
//     });

//     items[index].classList.add("active");
//   };

//   useEffect(() => {
//     const carouselEl = document.getElementById("carouselId");
//     if (!carouselEl || Banner.length === 0) return;

  
//     if (carouselInstanceRef.current) {
//       carouselInstanceRef.current.dispose();
//       carouselInstanceRef.current = null;
//     }

  
//     if (window.bootstrap?.Carousel) {
//       carouselInstanceRef.current = new window.bootstrap.Carousel(carouselEl, {
//         interval: 3000,
//         pause: 'hover',
//         ride: 'carousel'
//       });
//     }

//     const handleSlideChange = (event) => {
//       const newSlide = event.to + 1;
//       setCurrentSlide(newSlide);

      
//       const items = document.querySelectorAll(".circle-list li");
//       if (items.length > 0) {
//         textIndexRef.current = (textIndexRef.current + 1) % items.length;
//         rotateText(textIndexRef.current);
//       }
//     };

//     carouselEl.addEventListener("slide.bs.carousel", handleSlideChange);

//     return () => {
//       carouselEl.removeEventListener("slide.bs.carousel", handleSlideChange);
      
    
//       if (carouselInstanceRef.current) {
//         carouselInstanceRef.current.dispose();
//         carouselInstanceRef.current = null;
//       }
//     };
//   }, [Banner]); 

//   useEffect(() => {
//     if (Banner.length > 0) {
//       rotateText(0);
//     }
//   }, [Banner]);

//   return (
//     <section>
//       <div className="row g-0 mx-0">
        
//         {/* <div className="col-lg-6 banner-left">   */}
        
// <div className={`col-lg-6 ${styles.bannerLeft}`}>
//             <div className="video">
//               <video
//                 // className="sphere"
//                  className={styles.bannerVideo}
//                 src="/NLFanimation.mp4"
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//               />
//             </div>
//           </div>

//       <div className="container-fluid col-lg-6 px-0">
//         <div
//           id="carouselId"
//           className="carousel slide nlf-carousel"
//           data-bs-ride="carousel"
//           data-bs-interval="3000"
//           data-bs-pause="hover"
//         >
//           <div
//             className="carousel-inner"
//             role="listbox"
//             style={{
//               backgroundImage: `url(https://cyberathon.com/NLF/${Banner[currentSlide - 1]?.bnr_image})`,
//               backgroundRepeat: "no-repeat",
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//             }}
//           >
//             {Banner.map((Data, index) => (
//               <div
//                 key={index}
//                 className={`carousel-item ${index === 0 ? "active" : ""}`}
//               >
//                 <div className="banner-row">
//                   <div className="banner-image text-center">
//                     <h1 className="text-white mb-3">{Data.bnr_heading}</h1>
//                     <img src={`https://cyberathon.com/NLF/${Data.bnr_image}`} alt={Data.bnr_heading} />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="slide-number">
//             {currentSlide} / {totalSlides}
//           </div>

//           <button
//             className="nlf-carousel-control nlf-carousel-prev"
//             type="button"
//             data-bs-target="#carouselId"
//             data-bs-slide="prev"
//           >
//             <span className="nlf-control-icon" aria-hidden="true">
//               <svg viewBox="0 0 24 24">
//                 <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
//               </svg>
//             </span>
//           </button>

//           <button
//             className="nlf-carousel-control nlf-carousel-next"
//             type="button"
//             data-bs-target="#carouselId"
//             data-bs-slide="next"
//           >
//             <span className="nlf-control-icon" aria-hidden="true">
//               <svg viewBox="0 0 24 24">
//                 <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"></path>
//               </svg>
//             </span>
//           </button>
//         </div>
//       </div>
//       </div>
//     </section>
//   );
// }

// export default Slider;


// 5th june video dynamic code of slider
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import styles from "./Slider2.module.css";

function Slider() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [totalSlides, setTotalSlides] = useState(0);
  const [Banner, setBanner] = useState([]);
  const [videoSrc, setVideoSrc] = useState(""); // NEW: dynamic video
  const textIndexRef = useRef(0);
  const carouselInstanceRef = useRef(null);

  // Existing banner fetch
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/home_banner_list"
      );
      setBanner(response.data.data);
      setTotalSlides(response.data.data.length);
    };
    fetchData();
  }, []);

  // NEW: Fetch video from API
  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_videos"
        );
        const videos = response.data.data;
        if (videos && videos.length > 0) {
          // First item is latest (id:3), use it
          setVideoSrc(`https://cyberathon.com/NLF/${videos[0].nlf_video}`);
        }
      } catch (error) {
        console.error("Video fetch failed:", error);
        setVideoSrc("/NLFanimation.mp4"); // fallback to static
      }
    };
    fetchVideo();
  }, []);

  const rotateText = (index) => {
    const items = document.querySelectorAll(".circle-list li");
    if (!items.length) return;
    items.forEach((item, i) => {
      item.classList.remove("active");
      item.style.transform = `rotateY(${(i - index) * 51}deg) translateZ(160px)`;
    });
    items[index].classList.add("active");
  };

  useEffect(() => {
    const carouselEl = document.getElementById("carouselId");
    if (!carouselEl || Banner.length === 0) return;

    if (carouselInstanceRef.current) {
      carouselInstanceRef.current.dispose();
      carouselInstanceRef.current = null;
    }

    if (window.bootstrap?.Carousel) {
      carouselInstanceRef.current = new window.bootstrap.Carousel(carouselEl, {
        interval: 3000,
        pause: "hover",
        ride: "carousel",
      });
    }

    const handleSlideChange = (event) => {
      const newSlide = event.to + 1;
      setCurrentSlide(newSlide);
      const items = document.querySelectorAll(".circle-list li");
      if (items.length > 0) {
        textIndexRef.current = (textIndexRef.current + 1) % items.length;
        rotateText(textIndexRef.current);
      }
    };

    carouselEl.addEventListener("slide.bs.carousel", handleSlideChange);

    return () => {
      carouselEl.removeEventListener("slide.bs.carousel", handleSlideChange);
      if (carouselInstanceRef.current) {
        carouselInstanceRef.current.dispose();
        carouselInstanceRef.current = null;
      }
    };
  }, [Banner]);

  useEffect(() => {
    if (Banner.length > 0) {
      rotateText(0);
    }
  }, [Banner]);

  return (
    <section>
      <div className="row g-0 mx-0">

        <div className={`col-lg-6 ${styles.bannerLeft}`}>
          <div className="video">
            {/* CHANGED: src is now dynamic, falls back to static if API not loaded yet */}
            <video
              className={styles.bannerVideo}
              src={videoSrc || "/NLFanimation.mp4"}
              autoPlay
              loop
              muted
              playsInline
              onLoadedMetadata={(e) => {
    console.log(
      "Video:",
      e.target.videoWidth,
      e.target.videoHeight
    );
  }}
            />
          </div>
        </div>

        <div className="container-fluid col-lg-6 px-0">
          <div
            id="carouselId"
            className="carousel slide nlf-carousel"
            data-bs-ride="carousel"
            data-bs-interval="3000"
            data-bs-pause="hover"
          >
            <div
              className="carousel-inner"
              role="listbox"
              style={{
                backgroundImage: `url(https://cyberathon.com/NLF/${Banner[currentSlide - 1]?.bnr_image})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              {Banner.map((Data, index) => (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                >
                  <div className="banner-row">
                    <div className="banner-image text-center">
                      <h1 className="text-white mb-3">{Data.bnr_heading}</h1>
                      <img
                        src={`https://cyberathon.com/NLF/${Data.bnr_image}`}
                        alt={Data.bnr_heading}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="slide-number">
              {currentSlide} / {totalSlides}
            </div>

            <button
              className="nlf-carousel-control nlf-carousel-prev"
              type="button"
              data-bs-target="#carouselId"
              data-bs-slide="prev"
            >
              <span className="nlf-control-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                </svg>
              </span>
            </button>

            <button
              className="nlf-carousel-control nlf-carousel-next"
              type="button"
              data-bs-target="#carouselId"
              data-bs-slide="next"
            >
              <span className="nlf-control-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"></path>
                </svg>
              </span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Slider;